import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IInitialState } from './types'

import { reducers } from './reducers'
import { getPaymentCheckThunk, getPaymentPlansThunk, getZiinaUserThunk } from './asyncthunk'
import { RootState } from '../../Store'



const initialState: IInitialState = {
    loading: false,
    error: null,
    paymentPlans: [],
    checkPayment: null,
    paymentLoading: false,
    ziinaUser: null,
    ziinaAndroidError: null,
}

const PaymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: reducers,
    extraReducers: (builder) => {
        builder
            .addCase(
                getPaymentPlansThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.paymentPlans = action.payload
                },
            )
            .addCase(
                getPaymentCheckThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.checkPayment = action.payload
                },
            )
            .addCase(
                getZiinaUserThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.ziinaUser = action.payload
                },
            )
    }
})

export const {
setUpdatePaymentLoading,
setZiinaAndroidError,
} = PaymentSlice.actions
export const selectPaymentPlans = (state: RootState) => state.paymentReducer.paymentPlans
export const selectCheckPayment = (state: RootState) => state.paymentReducer.checkPayment
export const selectPaymentLoading = (state: RootState) => state.paymentReducer.paymentLoading
export const selectZiinaUser = (state: RootState) => state.paymentReducer.ziinaUser
export const selectZiinaAndroidError = (state: RootState) => state.paymentReducer.ziinaAndroidError


export default PaymentSlice.reducer